<template>
  <div class='quick-actions'>
    <div class='quick-actions__header'>
      <div class='quick-actions__header_text'>{{ title }}</div>
    </div>
    <div class='quick-actions__content'>
      <div v-if="is_loading">
        <content-placeholder :rows="placeholderRows"></content-placeholder>
      </div>
      <div v-else="true" class='quick-actions__content_wrap quick-actions__content_wrap--home'>
        <slot v-if="uses_custom_widget" name="custom_widget"></slot>
        <template v-else='true'>
          <div class='quick-actions__widget_holder'>
            <div class='quick-actions__widget_control_btns'>
              <a href='javascript:' class='kd-ibtn' @click="prev" v-tooltip="{title: 'Previous'}" aria-label="Previous" :class="{'is-disabled': viewingFirstWidget}" :tabindex="viewingFirstWidget ? '-1' : '0'" :aria-hidden="viewingFirstWidget ? 'true' : 'false'">
                <i class='kf kf-arrow-thin kf-flip-horizontal'></i>
              </a>
              <a href='javascript:' class='kd-ibtn' @click="next" v-tooltip="{title: 'Next'}" aria-label="Next" :class="{'is-disabled': viewingLastWidget}" :tabindex="viewingLastWidget ? '-1' : '0'" :aria-hidden="viewingLastWidget ? 'true' : 'false'">
                <i class='kf kf-arrow-thin kf-flip-vertical'></i>
              </a>
            </div>
            <carousel ref="carousel" :perPage="1" :paginationEnabled="false">
              <slide v-for="widget in widgets" :key="widgets.is">
                <slot name="widget" :widget="widget"></slot>
              </slide>
            </carousel>
          </div>
        </template>
        <div v-if="items.length > 0" class='quick-actions__item-list'>
          <slot v-for="item in items" name="item" :item="item"></slot>
        </div>
        <slot v-else="true" name="no_items">
          <div class='quick-actions__content_no-actions m2'>
            <div class='quick-actions__summary_watermark'>
              <span class='kf-stack kf-stack--circle'>
                <i class='kf kf-circle-outline'></i>
                <i class='kf kf-checkmark'></i>
              </span>
            </div>
            <div class='quick-actions__content_no-actions_title'>Congrats!</div>
            <div class='quick-actions__content_no-actions_subtitle'>You are all caught up! Time to grab a coffee!</div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import {Carousel, Slide} from 'vue-carousel';
  import ContentPlaceholder from 'vue-content-placeholder';

  export default {
    props: ['title', 'widgets', 'items', 'is_loading', 'uses_custom_widget'],
    components: {
      Carousel,
      Slide,
      ContentPlaceholder
    },
    data() {
      return {
        viewingFirstWidget: true,
        viewingLastWidget: false,
        placeholderRows:  [
          {
            height: '25px',
            boxes:[[0, 0], [0, 0]]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], ['1%', '75%']]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], [0, 0]]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], ['1%', '75%']]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], [0, 0]]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], ['1%', '75%']]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], [0, 0]]
          },
          {
            height: '25px',
            boxes:[['2%', '20%'], ['1%', '75%']]
          },
          {
            height: '25px',
            boxes:[[0, 0], [0, 0]]
          }
        ]
      }
    },
    methods: {
      prev() {
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        this.updateCarouselNav();
      },
      next() {
        this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
        this.updateCarouselNav();
      },
      updateCarouselNav() {
        this.viewingFirstWidget = this.$refs.carousel.currentPage === 0;
        this.viewingLastWidget = this.$refs.carousel.currentPage === (this.$refs.carousel.pageCount - 1);
      }
    }
  };
</script>
